import React from 'react';

function Loading({ active }) {
  let blockLoading = '';
  if (active) {
    blockLoading = (
      <div className="loading__overlay">
        <div className="loading__content">
          <div className="spinner" />
        </div>
      </div>
    );
  }
  return blockLoading;
}

export default Loading;
